(ns ycweb.app.website.mrprice.mrprice
  (:require
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]))

(rum/defcs staff-member-validation < rum/reactive (cmn/local nil ::node-atom) [local-atom app-atom]
  (let [node-atom (::node-atom local-atom)
        staff-atom (rum/cursor-in app-atom [:mrprice :staff-member])
        user (cmn/curact app-atom :user)]
    (cond
      (or (nil? user) (= 2 (:user_id user)))
      [:div
       {:class (u/bem :yc-page-content [:standard])}
       [:div.u-block-center.u-max-width-480
        [:div.u-block.u-text-center.u-margin-bottom-8
         (web-common/lazy-image app-atom
           "/pages/mr-price/mr-price-group-ltd.png"
           {:class ["yc-simple-image"]}
           {:w 160
            :q "auto"
            :alt "Mr Price South Africa"})]

        (headings/heading "Account Link"
          {:type :h1
           :size :large
           :center true})
        (feedback/feedback :warning
          (list
            "Please "
            [:a.text-link {:href "/login.htm"} "log in"]
            " to link your account.")
          "You need to be logged in to link your Mr Price account.")
        (buttons/button-web "Log in"
          {:href "/login.htm"
           :style :primary
           :size :default})]]

      :else
      [:div
       {:class (u/bem :yc-page-content [:standard])}
       [:form.u-block-center.u-max-width-480
        {:ref (fn [node] (reset! node-atom node))}
        [:div.u-block.u-text-center.u-margin-bottom-8
         (web-common/lazy-image app-atom
           "/pages/mr-price/mr-price-group-ltd.png"
           {:class ["yc-simple-image"]}
           {:w 160
            :q "auto"
            :alt "Mr Price South Africa"})]

        (headings/heading "Account Link"
          {:type :h1
           :size :large
           :center true})

        (forms/split-input-field
          ["First Name:" "e.g. Jane" (rum/cursor staff-atom :firstname) {:type :user :required? true :auto-focus true}]
          ["Last Name:" "e.g. Smith" (rum/cursor staff-atom :lastname) {:type :user}])

        (forms/input "Value Card Barcode Number:" "" (rum/cursor staff-atom :employee-id) {:required? true})

        (forms/input "Associate (Sponsor) South African ID:" "" (rum/cursor staff-atom :id-number) {:required? true})

        [:div.form-control
         (buttons/button-web "Link account"
           {:on-click
            (forms/form-validate node-atom #(grid/dispatch-action app-atom :web.mrprice/staff-member staff-atom))
            :type :button
            :style :primary
            :size :default
            :disabled
            (or
              (empty? (cmn/curact staff-atom :firstname))
              (empty? (cmn/curact staff-atom :lastname))
              (empty? (cmn/curact staff-atom :employee-id))
              (empty? (cmn/curact staff-atom :id-number)))})]]])))

(rum/defc staff-member < rum/reactive [app-atom]
  (let [mrprice-atom (rum/cursor app-atom :mrprice)
        user (cmn/curact app-atom :user)
        firstname
        (or
          (cmn/curact mrprice-atom [:staff-member :firstname])
          (:firstname user))
        registered-response (cmn/curact mrprice-atom :registered)]
    [:div
     {:class (u/bem :yc-page-content [:standard])}
     [:div.yc-section.yc-section--medium
      (cond
        registered-response
        [:div.u-block-center.u-max-width-640
         [:div.u-block.u-text-center.u-margin-bottom-8
          (web-common/lazy-image app-atom
            "/pages/mr-price/mr-price-group-ltd.png"
            {:class ["yc-simple-image"]}
            {:w 160
             :q "auto"
             :alt "Mr Price South Africa"})]

         (headings/heading "Account linked successfully"
           {:type :h1
            :size :large
            :center true})

         [:p.yc-paragraph.u-text-center
          (str
            "Welcome to the Yuppiechef family, "
            firstname
            "! You’ll be able to apply your discount at checkout. Happy shopping.")]

         [:div.flex-grid-group
          [:div
           {:class (u/bem :flex-grid-block [:m-1-2 :m-order-02])}
           [:div.flex-grid-content
            (buttons/button-web "Start shopping"
              {:href "/index.htm"
               :style :primary
               :size :default
               :full true})]]
          [:div
           {:class (u/bem :flex-grid-block [:m-1-2 :m-order-01])}
           [:div.flex-grid-content
            (buttons/button-web "View your account"
              {:href "/myaccount.htm"
               :style :secondary
               :size :default
               :full true})]]]

         [:p.yc-paragraph.u-text-center
          "Employee details changed? "
          [:a.text-link
           {:href "#"
            :on-click
            (fn [e]
              (.preventDefault e)
              (swap! mrprice-atom assoc :registered nil))}
           "Update your details"]]]

        :else
        (staff-member-validation app-atom))
      (toaster/loading-overlay app-atom :web.mrprice/loading)]]))

(defmethod flow/render-screen :web.mrprice [app-atom _]
  (website/screen-wrapper app-atom
    (staff-member app-atom)
    {:banner-type "Footer Ads" :banner-limit 4}))

(defmethod t/transition-open :web.mrprice [app-atom _ _]
  (let [user (cmn/curact app-atom :user)]
    (when
      (not
        (= 2 (:id user)))
      (toaster/open-overlay app-atom :web.mrprice/loading)
      (comms/ajax-get :web.mrprice/validate-user {}))))

(defmethod comms/receive :web.mrprice/validate-user [app-atom {:keys [msg] :as e}]
  (let [state-atom (rum/cursor-in app-atom [:mrprice :registered])]
    (reset! state-atom msg)
    (toaster/close-overlay app-atom :web.mrprice/loading)))

(defmethod grid/action :web.mrprice/staff-member [app-atom]
  (let [user (cmn/curact app-atom :user)]
    (grid/confirm-modal
      app-atom
      {:title "Confirmation"
       :text [:p (str "Please confirm that your Yuppiechef account (" (:email user) "), will be linked to the employee details submitted.")]
       :confirm-text "Confirm" :confirm-key :web.mrprice/modal-confirm})))

(defmethod grid/action :web.mrprice/modal-confirm [app-atom]
  (let [{:keys [firstname lastname employee-id id-number]}
        (get-in @app-atom [:mrprice :staff-member])
        user (get @app-atom :user)

        msg
        {:first-name firstname
         :last-name lastname
         :employee-id employee-id
         :id-number id-number
         :user-uuid (:uuid user)}]
    (toaster/open-overlay app-atom :web.mrprice/loading)

    (comms/ajax-get :web.mrprice/staff-member msg)
    (grid/close-modal app-atom)))

(defmethod comms/receive :web.mrprice/staff-member [app-atom {:keys [registered] :as e}]
  (let [state-atom (rum/cursor-in app-atom [:mrprice :registered])]
    (reset! state-atom registered)
    (toaster/close-overlay app-atom :web.mrprice/loading)))